import { Button, SxProps } from "@mui/material";
import React from "react";
import { UploadIcon } from "../Icon/UploadIcon";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { UILabel } from "../BuildlingBlocks/UILabel";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorImageInterface {
    editObject: object;
    label?: string;
    hint?: string;
    propertyName: string;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export function PropertyEditorImage(props: PropertyEditorImageInterface) {
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        const reader = new FileReader();
        reader.onload = (event) => {
            Reflect.set(props.editObject, props.propertyName, event.target?.result);
            StateManager.propertyChanged(props.editObject, props.propertyName);
        };

        if (file) {
            reader.readAsDataURL(file);
        }

        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <Button
                            data-testid={"property-editor-image"}
                            variant="contained"
                            sx={{ background: UIStyleConstants.BLUE_COLOR, ...props.sx }}
                            component="label"
                            startIcon={<UploadIcon />}
                        >
                            <UILabel>{props.label}</UILabel>
                            <input
                                type="file"
                                hidden
                                onChange={onChange}
                                accept="image/*"
                            />
                        </Button>
                        <UILabel
                            color={validationIssues ? UIStyleConstants.RED_COLOR : undefined}
                            variant={"hint"}
                        >
                            {validationIssues?.message ?? props.hint}
                        </UILabel>
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
}
